import { fetchJson } from "./http";

const API_URL = "https://lborrito.de/api/v1/events";

export async function fetchEvents(from, to) {
  const response = await fetch(`${API_URL}?from=${from}&to=${to}`, {
    credentials: "include",
  });
  if (!response.ok) {
    throw new Error("Fehler beim Laden der Events");
  }
  return response.json();
}

/**
 * 🔐 POST /api/v1/events
 * Erstellt ein neues Event für einen Kontakt
 */
export async function createEvent({ contactId, title, description, eventDate }) {
  return fetchJson(API_URL, {
    method: "POST",
    body: { contactId, title, description, eventDate },
  });
}

/**
 * 🔐 PATCH /api/v1/events/{eventId}
 * Aktualisiert Event-Details (Beschreibung, Datum)
 * Auto-Save wird mit Debouncing aufgerufen
 */
export async function updateEvent(eventId, updateData) {
  const bodyObj = {};
  
  if (updateData.description !== undefined) bodyObj.description = updateData.description;
  if (updateData.eventDate !== undefined) bodyObj.eventDate = updateData.eventDate;

  return fetchJson(`${API_URL}/${eventId}`, {
    method: "PATCH",
    body: bodyObj,
  });
}

/**
 * 🔐 DELETE /api/v1/events/{eventId}
 * Löscht ein Event
 */
export async function deleteEvent(eventId) {
  return fetchJson(`${API_URL}/${eventId}`, {
    method: "DELETE",
  });
}

